<template>
  <div class="md-layout">
    <div id="objectHeaderContentHidden" style="display: none;">
      <div><md-icon :class="list.pageIcon" class="icon-color">{{list.pageIcon}}</md-icon></div>
      <div>
        <h1 class="md-title icon-color">{{ $route.name }}</h1>
      </div>
    </div>

    <ElasticList :list="list"></ElasticList>
  </div>
</template>

<script>
  import ElasticList from "@/components/DynamicForm/ElasticList";
  import Page from '@/mixins/Page';
  import moment from "moment";

  export default {
    components: {
      ElasticList
    },
    mixins: [Page],
    data() {
      return {
        list: {
          hideListHeader: true,
          editPath: "services",
          linkRows: true,
          pageTitle: "Services",
          pageIcon: "styles",
          listQueryId: "searchServiceCustoms",
          deleteQueryId: "deleteService",
          responseFieldName: "searchServices",
          columns: {
            accountName: { label: "Account", sortable: false },
            name: { label: "DBA Name", sortable: true },
            nameLegal: { label: "Legal Name", sortable: true },
            merchantNumber: { label: "MID", sortable: false },
            status: { label: "Status", sortable: false },
            // salesRep: { label: "Sales Rep", sortable: false },
            portfolio: { label: "Portfolio", sortable: false },
            phoneBusiness: { label: "Primary Phone", sortable: false },
            physicalAddress: { label: "Physical Address", sortable: false },
            city: { label: "City", sortable: false },
            state: { label: "State", sortable: false },
            IPCorp: { label: "IP Corp", sortable: false },
            isRestructured: { label: "Restructured", sortable: false },
            dateSubmitted: { label: "Submitted", sortable: false },
            approvalDate: { label: "Approved", sortable: false },
            dateFirstProcessing: { label: "Processing Live", sortable: false },
          },
          formatResponse: data => {
            const result = [];
            const items = this.$reduce(data, 'searchServices.items');
            if (items && items.length) {
              items.forEach((_item) => {
                _item.accountName = this.$reduce(_item, 'account.name');
                _item.phoneBusiness = _item.phoneBusiness ? _item.phoneBusiness : '';
                _item.merchantNumber = _item.merchantNumber ? _item.merchantNumber : '';
                _item.nameLegal = _item.nameLegal ? _item.nameLegal : '';
                 _item.IPCorp = _item.IPCorp ? _item.IPCorp : 'false';
                _item.isRestructured = _item.isRestructured ? _item.isRestructured : 'false';
               _item.dateSubmitted = _item.dateSubmitted ? moment(_item.dateSubmitted).format('MM/DD/YYYY') : ""
                _item.approvalDate = _item.approvalDate ? moment(_item.approvalDate).format('MM/DD/YYYY')  : ""
                _item.dateFirstProcessing = _item.dateFirstProcessing ? moment(_item.dateFirstProcessing).format('MM/DD/YYYY') : ""
                
                let itemAddress = _item.addressPhysical;
                if (typeof itemAddress !== 'undefined' && itemAddress) {
                  try {
                    let parsedAddress = JSON.parse(itemAddress);
                    _item.city = this.$reduce(parsedAddress, 'locality');
                    //let region = this.$reduce(parsedAddress, 'region') ? this.$reduce(parsedAddress, 'region').split('_') : ""; 
                    //_item.state = region && region.length > 1 ? region[1] : this.$reduce(parsedAddress, 'region');
                    let region = parsedAddress.region.replace(/_/g, ' ').substring(2);
                    _item.state = region;
                    _item.physicalAddress = this.$reduce(parsedAddress, 'street_address');
                  } catch (error) {
                    console.log("Services => Json parse error", error)
                  }
                }

                if (typeof _item.portfolios !== 'undefined' && _item.portfolios && _item.portfolios.items && _item.portfolios.items.length) {
                  let firstPortfolio = _item.portfolios.items[0].portfolio.name;
                  _item.portfolio = firstPortfolio;                  
                }

                if (typeof _item.cases !== 'undefined' && _item.cases && _item.cases.items && _item.cases.items.length) {
                  let firstCase = _item.cases.items[0].case;
                  if(firstCase && firstCase.salesreps && firstCase.salesreps && firstCase.salesreps.items && firstCase.salesreps.items.length) {
                    let salesrep = firstCase.salesreps.items[0].salesrep;
                    let givenName = salesrep.given_name ? salesrep.given_name : "";
                    let familyName = salesrep.family_name ? salesrep.family_name : "";
                    let salesrepName = `${givenName} ${familyName}`.trim();
                    _item.salesRep = salesrepName;
                  }
                }

                if (typeof _item.status !== 'undefined' && _item.status) {
                  _item.status = _item.status.replace(/_/g, ' ');
                }
              
                result.push(_item);
              });
            }
            return result;
          },
          addonFilters: [
            {
              id: 'status',
              query: 'listServiceStatusEnum',
              queryOptionsKey: 'enumValues',
              key: 'name',
              label: 'name',
              placeholder: 'Status',
              modal: '',
              value: '',
            },
          ],
          perPageOptions: [5, 10, 20, 25, 50],
          defaults: {
            sort: 'createdAt',
            sortDir: 'desc',
            perPage: 10,
          },
          fuseSearch: null,
        },
      };
    },
  };
</script>

<style></style>
